module.exports = __webpack_public_path__ + "img/5185_9_SD.a050b9c3.svg";